import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Madres hispanas en EE.UU. con bebés de 4 a 24 meses.', 'Mujeres que trabajan y sienten que la falta de sueño está afectando su rendimiento profesional.', 'Madres que quieren una crianza respetuosa pero que necesitan resultados reales y rápidos.', 'Parejas que han dejado de ser "pareja" para convertirse en "turnos de vigilancia" nocturna.'];
  const notForWho = ['Personas que buscan una "pastilla mágica" sin cambiar la rutina diaria del bebé.', 'Padres que no están dispuestos a ser constantes durante al menos 72 horas.', 'Bebés con condiciones médicas no tratadas que afecten el sueño (siempre consulta a tu pediatra primero).'];
  return <section className="py-20 px-4 bg-cream-100 text-navy-900" data-id="element-13">
      <div className="max-w-6xl mx-auto" data-id="element-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12" data-id="element-15">
          {/* Para ti si... */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-md border-t-4 border-green-500" data-id="element-16">
            <h3 className="text-2xl md:text-3xl font-display font-bold text-navy-950 mb-8" data-id="element-17">
              Este programa es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-18">
              {forWho.map((item, index) => <li key={index} className="flex items-start space-x-4" data-id="element-19">
                  <div className="bg-green-100 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-20">
                    <CheckIcon className="w-5 h-5 text-green-600" data-id="element-21" />
                  </div>
                  <span className="text-navy-700 font-body leading-relaxed" data-id="element-22">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti si... */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-md border-t-4 border-red-400" data-id="element-23">
            <h3 className="text-2xl md:text-3xl font-display font-bold text-navy-950 mb-8" data-id="element-24">
              NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-25">
              {notForWho.map((item, index) => <li key={index} className="flex items-start space-x-4" data-id="element-26">
                  <div className="bg-red-50 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-27">
                    <XIcon className="w-5 h-5 text-red-500" data-id="element-28" />
                  </div>
                  <span className="text-navy-700 font-body leading-relaxed" data-id="element-29">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}